module.exports = __webpack_public_path__ + "img/img-bajo.05bf35ac.jpg";